import { TypeSpec } from './SidekickModuleSpec';

export class ExternalAppsTemplate {
  id: string; // generated in the code
  appNamespace: string;
  externalAppId: string;
  templateId: string;
  templateDescription: string;
  graphql: GraphQLMeta;
}

export class AppTemplateData {
  namespace: string;
}

export class GraphQLMeta {
  type: string;
  namespace: string;
  typeSpec: TypeSpec;
}
